<script setup>
  import { ref } from 'vue';
  import { useAuthenticated } from '@othercommerce/foundation';

  const session = useAuthenticated();

  const showCategories = ref(false);
  const showMenu = ref(false);
</script>
<template>
  <nav id="bottom-navigation" class="navigation">
    <ul :aria-label="$t('SHOP.COMMON.ARIA.BOTTOM_MENU')" class="navigation__menu">
      <li class="navigation__item">
        <button class="navigation__element" @click="showMenu = true">
          <SfIconHamburger aria-hidden="true" class="navigation__icon navigation__icon--default" />
          <span>{{ $t('SHOP.COMMON.ACTION.MENU') }}</span>
        </button>
      </li>
      <li class="navigation__item">
        <button class="navigation__element" @click="showCategories = true">
          <SfIconCategoriesMenu aria-hidden="true" class="navigation__icon navigation__icon--default" />
          <span>{{ $t('SHOP.COMMON.ACTION.CATEGORIES') }}</span>
        </button>
      </li>
      <li class="navigation__item">
        <!--        @TODO aria-current -->
        <RouterLink :href="$route('web.product.index')" class="navigation__element">
          <SfIconShoppingBag aria-hidden="true" class="navigation__icon" />
          {{ $t('SHOP.COMMON.ACTION.SHOP') }}
        </RouterLink>
      </li>
      <li class="navigation__item">
        <!-- when user is not logged in those two routes redirect to the same route, so two menu item gets .active class - in order to reset .active styles when needed we can add an extra unauthenticated-whisthist class -->
        <RouterLink :class="{'navigation__element--unauthenticated': !session  }" :href="$route('web.account.wishlist.index')" class="navigation__element" explicit>
          <SfIconHeartFill aria-hidden="true" class="navigation__icon" />
          {{ $t('SHOP.COMMON.ACTION.WISHLISTS') }}
        </RouterLink>
      </li>
      <li class="navigation__item">
        <RouterLink :href="$route('web.account.show')" class="navigation__element" explicit>
          <SfIconPerson aria-hidden="true" class="navigation__icon" />
          {{ $t('SHOP.COMMON.ACTION.ACCOUNT') }}
        </RouterLink>
      </li>
    </ul>
  </nav>
  <SfDrawerCategories v-model:open="showCategories" />
  <MenuDrawer v-model:open="showMenu" />
</template>

<style lang="scss" scoped>
  .navigation {
    background-color: var(--color-white);
    height: 58px;
    box-shadow: var(--secondary-box-shadow-200);

    &__menu {
      display: flex;
      justify-content: space-evenly;
      height: 100%;
      list-style: none;
      font-size: 0.75rem;
    }

    &__item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 0.125rem;
      width: 20%;
      font-size: 0.75rem;
      color: var(--color-default);

      a,
      button {
        outline-offset: 2px;
      }
    }

    &__element {
      background-color: transparent;
      border: none;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 0.125rem;
      font-size: 0.75rem;
      color: var(--color-default);

      &.active {
        color: var(--primary-color);
      }

      &--unauthenticated {
        &.active {
          color: var(--color-black);
        }
      }
    }

    &__icon {
      font-size: 1.25rem;
      fill: var(--color-white);

      &--default {
        fill: var(--color-black);
      }
    }

    @media (display-mode: standalone) {
      height: 68px;
      padding-bottom: 0.75rem;
    }
  }
</style>
